import { getUrlParam } from 'core-components/helpers/url'

export const getUrlFYear = () => {
  const urlFYear = getUrlParam('fyear')
  if (!urlFYear) {
    return null
  }

  const parsedFYear = parseInt(urlFYear, 10)
  if (isNaN(parsedFYear)) {
    return null
  }

  return parsedFYear
}
